// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__oLEzA","header":"ReportDetails_header__3J638","title":"ReportDetails_title__1T87n","left":"ReportDetails_left__1xEkw"};